export default __webpack_public_path__ + "static/media/x33.ce1a1e78.svg";